import React from "react";
import "./pagesCss/contect.css";

const Contact = () => {
  return (
    <div className="contect">
      <h1 style={{ color: "blue" }}>For any questions please drop a mail</h1>{" "}
      <br />
      <h1 style={{ color: "#FAFDD6" }}>bittu.bhadra123@gmail.com</h1> <br />
      <p>or</p> <br />
      <h1 style={{ color: "blue" }}>Contact me 👇</h1> <br />
      <h1 style={{ color: "#FAFDD6" }}>+918370819808, +917090459320</h1>
    </div>
  );
};

export default Contact;
